<template>
  <header class="main-header">
    <Video videoSource="../../assets/video/clouds.mp4" />
    <div class="main-header__countdown-box">
      <HeaderLogos />
      <h2><u>Countdown to disseminate the warning</u></h2>
      <FlipCountdown2 size="big"/>
      <p>Please scroll down</p>
      <MouseScrollDown />
    </div>
  </header>
</template>

<script>
import HeaderLogos from "../UI/HeaderLogos.vue";
import FlipCountdown2 from "../UI/FlipCountdown2.vue";
import Video from "../UI/Video.vue";
import MouseScrollDown from "../UI/MouseScrollDown.vue"

export default {
  components: {
    HeaderLogos,
    FlipCountdown2,
    Video,
    MouseScrollDown
  },
};
</script>

<style lang="scss" scoped>
@import "../../sass/_variables.scss";

.main-header {
  position: relative;
  height: 96vh;
  background-image: linear-gradient(
    to right bottom,
    rgba($color-grey-dark, .2),
    rgba($color-grey-dark-2, .2)
  );

  &__countdown-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -51%);
    text-align: center;
    width: 80%;
    height: 90%;
    box-shadow: 0 3rem 6rem rgba(0, 0, 0, 0.9);
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 1rem;
    padding: 3rem;
    font-size: 1.6rem;

    h2 {
     color: $color-primary; 
    }

    p {
      position: absolute; 
      top: 82%;
      left: 45%; 
      font-size: 2rem;
      color: $color-primary;
    }
  }
}
</style>
